import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Toaster } from "sonner";
import { ErrorBoundary } from "./components/ErrorBoundary.tsx";
import { ConfirmProvider } from "./components/ui/ConfirmDialog.tsx";
import { isRtlLang } from "./lib/locale.ts";
import { setupOfflineCache } from "./lib/offline-cache.ts";
import { queryClient } from "./lib/query-client.ts";
import { router } from "./router.tsx";

// Persist the query cache to IndexedDB so data is readable offline; rehydrate
// on startup. Wiped on logout (auth-store) so PHI never lingers.
setupOfflineCache(queryClient);

export function App() {
	return (
		<ErrorBoundary>
			<QueryClientProvider client={queryClient}>
				<ConfirmProvider>
					<RouterProvider router={router} />
					<ToasterWithLang />
				</ConfirmProvider>
			</QueryClientProvider>
		</ErrorBoundary>
	);
}

function ToasterWithLang() {
	const { i18n } = useTranslation();
	const isRtl = isRtlLang(i18n.language);
	return (
		<Toaster
			position={isRtl ? "top-left" : "top-right"}
			richColors
			closeButton
			duration={3500}
			dir={isRtl ? "rtl" : "ltr"}
			// Clear the sticky app header (~57px + safe-area) so toasts never
			// cover the search/create/bell controls in the top corner.
			offset={72}
			mobileOffset={72}
		/>
	);
}
